const getFloorName = (floor, isCHT) => {
	let floorName = '';

	if (!isCHT && floor < 0) {
		floorName = `B${Math.abs(floor)}`;
	}

	if (!isCHT && floor > 0) {
		floorName = `L${floor}`;
	}

	if (isCHT && floor < 0) {
		floorName = `地下${Math.abs(floor)}樓`;
	}

	if (isCHT && floor > 0) {
		floorName = `${floor}樓`;
	}

	return floorName;
}

export default getFloorName;